import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {setCurrentAbeille, setCurrentRole} from '../../assets/utils.js';

@Component({
  selector: 'app-go-dashboard',
  templateUrl: './go-dashboard.component.html',
  styleUrls: ['./go-dashboard.component.scss']
})
export class GoDashboardComponent {

  constructor(private router: Router) { }

  goDashboard() {

      setCurrentAbeille(null);
      setCurrentRole(null);
      this.router.navigate(['/dashboard']);
  }

}
